import React from 'react'
import { IconButton, Heading, Flex } from 'theme-ui'
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton
} from 'react-share'
import attachSocialIcons from '@helpers/attachSocialIcons'

import faceIcon from '../../../../../site/content/assets/flexiblocks/homepage/educabot/face.svg'
import twitterIcon from '../../../../../site/content/assets/flexiblocks/homepage/educabot/twitt.svg'
import linkedInIcon from '../../../../../site/content/assets/flexiblocks/homepage/educabot/linkedin.svg'


const styles = {
  wrapper: {
    alignItems: `flex-start`
  },
  heading: {
    fontSize: '18px',
    color: `#6D7878`,
    mr: 1,
    mb: 0
  },
  socialBtn: {
    width: '50px',
    transition: 'all .2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.1)'
    }
  }
}



const PostShare = ({ location, title }) => {
  const url = location && location.href

  const Facebook = ({ children }) => (
    // <div style={{ marginRight: '10px'}}>
    //   <a href="https://www.facebook.com/EducabotArg">
    //     <img style={{width: '30px'}} src={faceIcon} />
    //   </a>
    // </div>
    <FacebookShareButton style={{ fontSize: '25px', color: '#42B3FF' }} size={32} url={'https://www.facebook.com/EducabotArg'}>
    {children}
    </FacebookShareButton>
  )

  const Twitter = ({ children }) => (
    // <div style={{ marginRight: '10px', width: '30px'}}>
    //   <a href="https://twitter.com/EducabotArg" target="_blank">
    //     <img style={{width: '30px'}} src={twitterIcon} />
    //   </a>
    // </div>
    <TwitterShareButton style={{ fontSize: '25px', color: '#42B3FF' }} url={'https://twitter.com/EducabotArg'} title={title}>
      {children}
    </TwitterShareButton>
  )

  const Linkedin = ({ children }) => (
    // <div className={styles.socialBtn}>
    //   <a href="https://www.linkedin.com/company/educabot" target="_blank">
    //     <img style={{width: '30px'}} src={linkedInIcon} />
    //   </a>
    // </div>
    <LinkedinShareButton style={{ fontSize: '25px', color: '#42B3FF' }} url={'https://www.linkedin.com/company/educabot'} quote={title}>
      {children}
    </LinkedinShareButton>
  )

  // const Email = ({ children }) => (
  //   <EmailShareButton url={url} subject={title}>
  //     {children}
  //   </EmailShareButton>
  // )

  const buttons = {
    facebook: Facebook,
    twitter: Twitter,
    linkedin: Linkedin,
    // email: Email
  }

  const buttonsWithIcons = attachSocialIcons(
    Object.keys(buttons).map(s => ({ name: s }))
  )

  return (
    <Flex sx={styles.wrapper}>
      <Heading variant='h5' sx={styles.heading}>
        Compartí la noticia
      </Heading>
      {buttonsWithIcons.map(({ name, color, Icon }) => {
        const ShareButton = buttons[name]
        return (
          ShareButton && (
            <IconButton
              as='span'
              variant='simple'
              key={`share-${name}`}
              sx={styles.socialBtn}
            >
              <ShareButton>
                <Icon />
              </ShareButton>
            </IconButton>
          )
        )
      })}
    </Flex>
  )
}

export default PostShare
